<button type="button" [title]="'dialog.close' | translate" (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button>
	<mat-icon color="accent" svgIcon="md:close"></mat-icon>
</button>
<div class="copo-container settings-general">
	<div class="card-block">
		<div mat-dialog-title translate>user.card.about-cookies.title</div>
		<div class="privacy-settings">
			<span translate>user.card.about-cookies</span>
		</div>
		<div class="card-title" translate>user.card.cookies-exempt-from-consents.title</div>
		<div class="privacy-settings">
			<span translate>user.card.cookies-exempt-from-consents.one</span>
			<br />
			<span translate>user.card.cookies-exempt-from-consents.two</span>
			<br />
			<span translate>user.card.cookies-exempt-from-consents.three</span>
		</div>
	</div>
</div>